(function () {
  'use strict';
  function mgr() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && E.sdk.getPriceTestManager) return E.sdk.getPriceTestManager();
    } catch (_) {}
    return null;
  }
  function apply(pid, vid) {
    var m = mgr();
    if (!m) return;
    try {
      if (pid && vid && m.updatePricesForProduct) m.updatePricesForProduct(pid, vid);
      else if (m.updatePricesOnCurrentPage) m.updatePricesOnCurrentPage();
    } catch (_) {}
  }

  // The theme swaps the PDP price innerHTML with the ORIGINAL price after a
  // fetch (product.js renderProductInfo), and the 'product:variant-change' event
  // fires BEFORE that fetch resolves. So watch the DOM and re-apply synchronously
  // (microtask, before paint) when a fresh .price[data-product-id] lands.
  var pending = null;
  function onAdded(n) {
    if (n.nodeType !== 1) return;
    var nodes = n.matches && n.matches('.price[data-product-id]') ? [n] : [];
    if (n.querySelectorAll) nodes = nodes.concat([].slice.call(n.querySelectorAll('.price[data-product-id]')));
    nodes.forEach(function (el) {
      apply(el.getAttribute('data-product-id'), el.getAttribute('data-variant-id'));
    });
    if (!nodes.length && n.querySelector && n.querySelector('[data-product-id]')) pending = true;
  }
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (muts) {
      pending = false;
      muts.forEach(function (m) { [].forEach.call(m.addedNodes, onAdded); });
      if (pending) apply(); // ponytail: full rescan for other injected cards; debounce if chatty
    });
    var start = function () { obs.observe(document.body, { childList: true, subtree: true }); };
    document.body ? start() : document.addEventListener('DOMContentLoaded', start);
  }

  // Initial pass once the SDK is up (it may fire eraya:ready before exposing sdk).
  if (window.ErayaReady) apply();
  window.addEventListener('eraya:ready', function () { setTimeout(apply, 0); });
})();
